// extracted by mini-css-extract-plugin
module.exports = {"player":"VideoPlayer_player__9rR1B"};